import { differenceInHours, differenceInMinutes, differenceInSeconds, format } from 'date-fns';

const formatDate = (date: Date, dateFormat = 'MMMM d, yyyy', fullTime?: boolean) => {
  const diffInMinutes = differenceInMinutes(new Date(), date);
  const diffInHours = differenceInHours(new Date(), date);
  const formattedDate = `${format(date, dateFormat)}`;

  if (fullTime) {
    return `${formattedDate}, ${format(date, 'hh:mm a')}`;
  }

  if (diffInMinutes < 60 && diffInMinutes > 0) {
    return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
  }
  if (diffInHours <= 6 && diffInHours > 0) {
    return `${diffInHours} hour${diffInHours === 1 ? '' : 's'} ago`;
  }

  return formattedDate;
};

export const getArticleDates = ({
  publishedDate,
  updatedAt = null,
  publishedAt,
  dateFormat,
  fullTime = false,
}: {
  publishedDate: string;
  updatedAt?: string;
  publishedAt: string;
  dateFormat?: string;
  fullTime?: boolean;
}): { updatedAt: string | null; publishedAt: string } => {
  const date = new Date(publishedDate || publishedAt);
  const updatedAtDate = updatedAt && new Date(updatedAt);
  const differenceBetweenDates = differenceInSeconds(updatedAtDate, date);

  return {
    updatedAt:
      differenceBetweenDates > 0
        ? `Edited ${formatDate(updatedAtDate, dateFormat, fullTime)}`
        : null,
    publishedAt: formatDate(date, dateFormat, fullTime),
  };
};
